module.exports = __webpack_public_path__ + "static/img/logo.70263dc.png";


//////////////////
// WEBPACK FOOTER
// ./static/pc/logo.png
// module id = kJBg
// module chunks = 0